import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';

import { trackOfferMessageTeaserShow } from '../OfferMessageContainer/tracking';
import { useMessageContext } from '../../../../utils/messageContext';
import { OfferMessageLayout } from '../../../../components/OfferMessageLayout';
import { ErrorSignContainer } from '../ErrorSignContainer';
import { ErrorTextContainer } from '../ErrorTextContainer';
import { ChatMessageMetaContainer } from '../ChatMessageMetaContainer';
import { ActionButtonsContainer } from '../ActionButtonsContainer';
import { ExpertButtonContainer } from '../OfferMessageContainer/containers/ExpertButtonContainer';
import { IOfferMessage } from '../OfferMessageContainer/types';
import { useOfferMessageActions } from '../OfferMessageContainer/hooks/useOfferMessageActions';
import { ERequestApiStatus } from '../../../../types/appState';
import { OfferMessage } from '../../../../components/OfferMessage';

export const ChatbotOfferMessageContainer: React.FC = () => {
  const {
    messageType,
    messageRef,
    isLastInChain,
    message: { offers, status, isOutcoming },
  } = useMessageContext();

  const offer = offers?.[0] as IOfferMessage | undefined;
  const { formattedText, shareUrl, handleReload, onClick } = useOfferMessageActions(offer);

  const handleTrackOfferMessageTeaserShow = React.useCallback(() => {
    if (offer) {
      trackOfferMessageTeaserShow({
        offerId: offer.realtyOfferId,
        block: 'Chat_cian_helper',
        mlSearchSessionGuid: offer.mlSearchSessionGuid ?? undefined,
        batchid: offer.batchTs ?? undefined,
        position: offer.position ?? undefined,
      });
    }
  }, [offer]);

  if (!offer) {
    return null;
  }

  return (
    <OfferMessageLayout
      errorSign={<ErrorSignContainer />}
      errorText={<ErrorTextContainer />}
      messageType={messageType}
      messageMeta={<ChatMessageMetaContainer />}
      actionButtons={<ActionButtonsContainer />}
      ref={messageRef}
      isLastMessageInChain={isLastInChain}
      offerMessage={
        <ActionAfterViewObserver
          percentVisible={0.5}
          callback={handleTrackOfferMessageTeaserShow}
          triggerOnce={false}
          callbackDelay={1000}
        >
          <OfferMessage
            isOutcoming={isOutcoming}
            isChatbotChat={true}
            withReload={status === ERequestApiStatus.Failed}
            formattedAddress={offer.formattedAddress}
            formattedInfo={offer.formattedInfo}
            formattedPrice={offer.formattedPrice}
            formattedOldPrice={offer.formattedOldPrice}
            formattedText={formattedText}
            shareUrl={shareUrl}
            photoUrl={offer?.photoUrls}
            messageRef={messageRef}
            onReload={handleReload}
            onClick={onClick}
            chatbotButtons={<ExpertButtonContainer offer={offer} />}
          />
        </ActionAfterViewObserver>
      }
    />
  );
};
